<template>
    <div class="row">
        <div class="col-sm-12">
            <div class="partners-banner-outer">
                <div class="row align-items-center">
                    <div class="col-lg-6 col-md-6" v-html="body_content">
                        
                    </div>
                    <div class="col-lg-6 col-md-6">
                        <div class="partners-banner-image-container">
                            <img fetchpriority="high" :src="image_url" alt="">
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
  
<script>
export default {
  data() {
    return {};
  },
  props: {
    body_content:{ type: String, default:'' },
    image_url: { type: String, default:'' }
  },
  methods: {},
};
</script>

  